import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './MultiSelectGrade.module.less';

const MultiSelectGrade = ({
  displayName,
  internalName,
  href,
  disabled = false,
  selected = false,
  onClick,
}) => {
  const handleClick = e => {
    if (!disabled && typeof onClick === 'function') {
      onClick(e, href);
    }
  };

  const content = <p>{displayName}</p>;

  const classes = clsx(styles.link, selected && styles.selected);

  let facetLink;
  if (selected) {
    // Selected middle chips -> not interactive but still selected
    facetLink = (
      <a className={classes} onClick={handleClick} tabIndex={0}>
        {content}
      </a>
    );
  } else {
    // Disabled chips -> hidden
    facetLink = (
      <a
        className={classes}
        href={disabled ? undefined : href}
        onClick={handleClick}
      >
        {content}
      </a>
    );
  }

  const dataCy = !disabled ? 'grade' : 'grade-disabled';

  return (
    <li
      key={internalName}
      className={clsx(styles.facet, !selected && disabled && styles.greyOut)}
      data-cy={dataCy}
    >
      {facetLink}
    </li>
  );
};

MultiSelectGrade.displayName = 'MultiSelectGrade';
MultiSelectGrade.propTypes = {
  displayName: PropTypes.string,
  internalName: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  interactive: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  count: PropTypes.number,
};

export default MultiSelectGrade;
